import { notificationConfig } from '../config/notification';

const tokenCache = {};
const refreshTimers = {};
const STORAGE_KEY_PREFIX = 'machineToken:';
const SAFETY_WINDOW_MS = 10_000;

function loadFromStorage(cacheKey) {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${cacheKey}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function saveToStorage(cacheKey, entry) {
  tokenCache[cacheKey] = entry;
  try {
    sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${cacheKey}`, JSON.stringify(entry));
  } catch { /* ignore */ }
}

function isValid(entry) {
  return entry && entry.accessToken && entry.expiresAt > Date.now() + SAFETY_WINDOW_MS;
}

async function fetchLocalJwt() {
  const base = (
    notificationConfig.smsApiBase ||
    'https://annadaneshwar-notification-service.azurewebsites.net'
  ).replace(/\/$/, '');

  const res = await fetch(`${base}/public/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ username: 'Anand', password: 'Anand@12' }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Local JWT login failed (${res.status}): ${text}`);
  }

  const data = await res.json();
  if (!data.token) throw new Error('No token in login response');

  const expiresAt = Date.now() + 23 * 60 * 60 * 1000;
  return { accessToken: data.token, expiresAt };
}

function scheduleRefresh(cacheKey, expiresAt) {
  if (refreshTimers[cacheKey]) clearTimeout(refreshTimers[cacheKey]);
  const refreshIn = Math.max(30_000, expiresAt - Date.now() - 60_000);
  refreshTimers[cacheKey] = setTimeout(() => {
    getToken(cacheKey).catch((err) => console.error('Token auto-refresh failed', err));
  }, refreshIn);
}

async function getToken(cacheKey) {
  const cached = tokenCache[cacheKey];
  if (isValid(cached)) return cached.accessToken;

  const stored = loadFromStorage(cacheKey);
  if (isValid(stored)) {
    tokenCache[cacheKey] = stored;
    scheduleRefresh(cacheKey, stored.expiresAt);
    return stored.accessToken;
  }

  const fresh = await fetchLocalJwt();
  saveToStorage(cacheKey, fresh);
  scheduleRefresh(cacheKey, fresh.expiresAt);
  return fresh.accessToken;
}

export async function getSmsToken() {
  return getToken('sms');
}

export async function primeSmsToken() {
  try {
    return await getSmsToken();
  } catch (err) {
    console.error('SMS token prime failed', err);
    throw err;
  }
}

export async function getCallToken() {
  return getToken('call');
}

export async function primeCallToken() {
  try {
    return await getCallToken();
  } catch (err) {
    console.error('Call token prime failed', err);
    throw err;
  }
}

export function clearToken(cacheKey) {
  delete tokenCache[cacheKey];
  if (refreshTimers[cacheKey]) {
    clearTimeout(refreshTimers[cacheKey]);
    delete refreshTimers[cacheKey];
  }
  try {
    sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${cacheKey}`);
  } catch { /* ignore */ }
}
